import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nh-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  constructor() { }

  // Lifecycle Hooks

  ngOnInit(): void {
  }

}
